import axios from "axios";
import {server} from "@/variables";

export function getPrices() {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/prices`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

export function updatePrice(object) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.post(`${server}/prices`, object, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

export function updatePriceBatch(object) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.post(`${server}/prices/batch`, object, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}